 /* global CryptoJS */
 
 window.SECRET_KEY = "12345678901234567890123456789012"; // 32 chars
    window.IV = CryptoJS.enc.Utf8.parse("abcdefghijklmnop"); // 16 chars

    // AES Encrypt
  export  const encryptAES = (payload) => {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        CryptoJS.enc.Utf8.parse(window.SECRET_KEY),
        {
          iv: window.IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      return encrypted.toString();
    };

    // AES Decrypt
 export  const decryptAES = (ciphertext) => {
      const decrypted = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(window.SECRET_KEY),
        {
          iv: window.IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      try {
        return JSON.parse(decryptedText);
      } catch (e) {
        console.warn("Decrypted string is not valid JSON:", decryptedText);
        return decryptedText;
      }
    };

